import { isHttpUrl } from "@/lib/http/is-http-url";
import { configReadString } from "@/lib/string/config-read-string";
/** A usable base URL, or nothing — "not a url" would otherwise reach
 *  `new URL()` in api.ts and break every command. */
export function readHttpUrl(value: unknown): string | undefined {
  const raw = configReadString(value);
  return raw && isHttpUrl(raw) ? raw : undefined;
}
